module.exports = __webpack_public_path__ + "73d6faa8c72bd0983c60f0804235ab31.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/blue-pattern.jpg
 ** module id = 260
 ** module chunks = 0
 **/